<template>
  <div class="LayoutHeader" :class="{ toFixed }" ref="LayoutHeader">
    <div class="LayoutHeader-cont">
      <div class="header-left">
        <img class="logo" alt="千里马招标信息" @click="handleLogo" src="../../assets/img/header/logo.svg" />
        <a class="go-old-home" :href="OLD_HOME_ZHAOBIAO" v-if="showOldVersion">
          <i class="iconfont icon-qiehuan" />
          <span>切换旧版</span>
        </a>
        <img
          v-if="isShowCustomUserCenter"
          class="custom-user-center"
          src="../../assets/img/header/icon-custom-user-center.png"
          alt="custom-user-center"
          width="122"
          height="22"
          @click="toCustomUserCenter"
        />
      </div>
      <LibHeaderInput v-if="hasHeaderInputRed"/>
      <LibSearchInput :placeholder="placeholder" v-if="!isShowCustomUserCenter && showSearchInput" />
      <div class="header-right">
        <p class="phone">
          <i class="iconfont icon-phone"></i> <span>{{ servicePhone() }}</span>
        </p>
        <!--产品服务-->
        <p>
          <ProductsServicesButtonModule />
        </p>
        <p>
          <span
            class="enterprise-package"
            v-track
            :data-oid="OID_MAP.ENTERPRISE_PACKAGE_CLICK"
            @click="goToUrl(ENTERPRISE_PACKAGE)"
          >
            企业套餐
          </span>
        </p>
        <p><a v-track :data-oid="OID_MAP.ABOUT_US_QLM_CLICK" :href="ABOUT_US" target="_blank">关于千里马</a></p>
        <template v-if="!isLogin">
          <el-button
            class="login-but"
            v-track
            :data-oid="OID_MAP.HEADER_LOGIN_CLICK"
            size="small"
            round
            @click="showLoginDialog"
          >
            登录
          </el-button>
          <el-button
            v-track
            :data-oid="OID_MAP.HEADER_REGISTER_CLICK"
            size="small"
            type="primary"
            round
            @click="showLoginDialog"
          >
            免费注册
          </el-button>
        </template>
        <template v-if="isLogin">
          <p class="userInfo">{{ userInfo.username }}</p>
          <p class="loginOut" @click="handleLoginOut">退出</p>
          <el-button
            class="login-but"
            v-track
            :data-oid="OID_MAP.HEADER_MEMBER_CLICK"
            size="small"
            round
            @click="handleCenter"
          >
            会员中心
          </el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ABOUT_US,
  CUSTOM_USER_CENTER_URL,
  ENTERPRISE_PACKAGE,
  OLD_HOME_ZHAOBIAO,
  OLD_USER_CENTER_URL,
  PUBLIC_PATH,
} from "../../utils/constants/constants";
import ProductsServicesButtonModule from "./ProductServicesButtonModule";
import {clearCookies, getServicePhone, isValEmpty} from "../../utils/common";
import { commonCusApiHomepageIdTypeGw, restUserApiHomepageLogout } from "../../services/home";
import { OID_MAP } from "../../utils/constants/constants.track";
import LibSearchInput from "../LibSearchInput/LibSearchInput.vue";
import LibHeaderInput from "../LibHeaderInput/LibHeaderInput"
export default {
  name: "LibLayoutHeader",
  components: { LibSearchInput, ProductsServicesButtonModule,LibHeaderInput },
  props: {
    upFixed: {
      type: Boolean,
      default: true,
    },
    fixedHeight: {
      type: Number,
      default: 220,
    },
    showOldVersion: {
      type: Boolean,
      default: true,
    },
    showSearchInput: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    loginSuccessGoData: {
      type: Object,
      default: () => {
        return {
          type: "open",
          url: OLD_USER_CENTER_URL,
        };
      },
    },
    hasHeaderInputRed:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      OID_MAP,
      ENTERPRISE_PACKAGE,
      ABOUT_US,
      OLD_HOME_ZHAOBIAO,
      toFixed: false,
      isEjected: "",
      scrollTop: 0,
      isShowCustomUserCenter: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters["basic/userInfo"];
    },
    isShowDialogLogin() {
      return this.$store.getters["basic/isShowDialogLogin"];
    },
    loginSuccessGo() {
      return this.$store.getters["basic/loginSuccessGo"];
    },
    isLogin() {
      return this.$store.getters["basic/isLogin"];
    },
  },
  watch: {
    scrollTop: {
      handler(newVal, oldVal) {
        if (newVal < oldVal) {
          this.toFixed = this.upFixed;
        } else {
          this.toFixed = false;
        }
      },
      immediate: true,
    },
  },
  methods: {
    servicePhone() {
      return getServicePhone(this.$store.getters["basic/isPayBefore"]);
    },
    showLoginDialog() {
      this.$store.commit("basic/updateIsShowDialogLogin", true);
      this.$store.commit("basic/updateLoginSuccessGo", this.loginSuccessGoData);
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },
    closeDialog() {
      this.$store.commit("basic/updateIsShowDialogLogin", false);
    },
    handleCenter() {
      window.open(OLD_USER_CENTER_URL);
    },
    handleLogo() {
      window.location.href = PUBLIC_PATH;
    },
    handleLoginOut() {
      this.$confirm("您确定要退出登录？", "提示", {
        confirmButtonText: "退出",
        cancelButtonText: "取消",
        lockScroll: false,
      })
        .then(async () => {
          try {
            await restUserApiHomepageLogout();
            this.$message({
              message: "您已退出",
              type: "info",
              onClose: () => {
                this.redirectToLoginPage();
              },
            });
          } catch (e) {
            this.$message({
              message: "退出失败，稍后重试",
              type: "error",
              onClose: () => {},
            });
          }
        })
        .catch(() => {});
    },
    // 跳转至登录页
    redirectToLoginPage() {
      // 清除cookies
      clearCookies();
      window.location.replace(PUBLIC_PATH);
    },
    goToUrl(path) {
      window.open(path);
    },
    async init() {
      if (this.isLogin) {
        const res = await commonCusApiHomepageIdTypeGw({ id: this.userInfo.userId });
        // type > 0 展示 --- 李雷鹏
        this.isShowCustomUserCenter = res.data.type > 0;
      }
    },
    toCustomUserCenter() {
      window.location.href = CUSTOM_USER_CENTER_URL;
    },
  },
  mounted() {
    this.init();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/config";

.LayoutHeader {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 999;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 2px 10px 0px rgba(114, 116, 121, 0.13);
  backdrop-filter: blur(15px);
  min-width: $layout-body-width;

  &.toFixed {
    height: 66px;
    position: fixed;
    top: 0;
    width: 100%;
    font-size: 14px;
  }

  .LayoutHeader-cont {
    max-width: $layout-fixed-width;
    min-width: $layout-body-width;
    padding: 0 70px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }

  .header-left {
    display: flex;
    align-items: center;

    .logo {
      cursor: pointer;
    }

    .go-old-home {
      &:hover {
        color: $theme-color;
        font-weight: $font-weight-Medium;
      }
    }

    .custom-user-center {
      margin-left: 26px;
      cursor: pointer;
    }
  }

  .go-old-home {
    color: #45464a;
    font-weight: $font-weight-Medium;
    margin-left: 25px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .iconfont {
      padding-right: 4px;
      color: #a3a6ab;
    }
  }

  .header-right {
    display: flex;
    align-items: center;

    & > p {
      margin-right: 26px;

      a {
        &:hover {
          color: $theme-color;
          font-weight: $font-weight-Medium;
        }
      }
    }

    .phone {
      color: #2a2b33;
      font-weight: $font-weight-Medium;
      display: flex;
      align-items: center;

      .iconfont {
        padding-right: 4px;
        color: #a3a6ab;
      }
    }

    .enterprise-package {
      padding-left: 24px;
      color: #be851d;
      background: url("../../assets/img/header/enterprise-package.png") no-repeat;
      background-size: 22px 22px;
      cursor: pointer;

      &:hover {
        color: #eba31f;
        font-weight: $font-weight-Medium;
      }
    }

    .el-button {
      width: 100px;
      font-weight: 550;

      &:hover {
        background: #f66d59;
        border-color: #f66d59;
      }
    }

    .login-but {
      background: rgba(0, 0, 0, 0);
      border-color: $theme-color;
      color: $theme-color;

      &:hover {
        background: rgba(0, 0, 0, 0);
        border-color: #f66d59;
        color: #f66d59;
      }
    }

    .userInfo {
      background: url("../../assets/img/header/avator.png") no-repeat;
      background-size: 22px 22px;
      background-position-x: left;
      background-position-y: center;
      padding-left: 24px;
    }

    .loginOut {
      cursor: pointer;

      &:hover {
        color: $theme-color;
      }
    }
  }
}
</style>
